import * as React from "react";
import { FunctionComponent, useState, useEffect } from 'react';
//when rebuilding after an NPM install follow the notes in readme!
import { ProgressBar } from "react-bootstrap";

import "react-datepicker/dist/react-datepicker.css";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input/input';
import { isValidPhoneNumber, formatPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import ReactTooltip from 'react-tooltip';

import { ClaimPackage } from "../../Models/ClaimPackage";
import { Claim, ClaimType } from "../../Models/Claim";
import Server from "../../Server";
import { ClaimSuccess } from "../ClaimSuccess";
import FileDragAndDrop from "../FileDragAndDrop";
import { FilesTable } from "../FilesTable";
import { CSSTransition } from 'react-transition-group';
import { ByteLimit, EmailRegex, ValidateEmail, FixDate, AfterToolTipHide, AfterToolTipShow, PrettyPrintDate } from "../../Utils";

interface PropertyClaimProps {
    isQuincy: boolean;
    claimPackage: ClaimPackage;
    progressBack: () => void;
}
export const PropertyClaim: FunctionComponent<PropertyClaimProps> = ({ isQuincy, claimPackage, progressBack }) => {
   
    const [policyName, setPolicyName] = useState<string>("");
    const [altFirst, setAltFirst] = useState<string>("");
    const [altLast, setAltLast] = useState<string>("");
    const [altRelation, setAltRelation] = useState<string>("");
    const [city, setCity] = useState<string>("");
    const [street, setStreet] = useState<string>("");
    const [state, setState] = useState<string>("");
    const [zip, setZip] = useState<string>("");
    const [primaryPhone, setPrimaryPhone] = useState<string>("");
    const [altPhone, setAltPhone] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [explanation, setExplanation] = useState<string>("");
    const [otherDamage, setOtherDamage] = useState<string>("N/A");
    const [damageAmount, setDamageAmount] = useState<string>("");
    const [damagedate, setDamageDate] = useState<Date>();
    const [files, setFiles] = useState<File[]>([]);
    const [showSuccess, setShowSuccess] = useState<boolean>(false);
    const [showError, setShowError] = useState<boolean>(false);
    const [uploadLimitBreached, setShowUploadLimitBreach] = useState<boolean>(false);
    const [fileSize, setFileSize] = useState<number>(0);
    const [progress, setProgress] = useState<number>(0);
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [responseError, setResponseError] = useState<string>("");
    const [width, setWidth] = useState<number>(window.innerWidth);
    const [showStart, setShowStart] = useState<boolean>(true);
    const[firstLoad, setFirstLoad] = useState<boolean>(true);
    const [showToolTip, setShowToolTip] = useState<boolean>(false);
    
    let toolTipRef: any = null;

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() =>{
        if(firstLoad)
        {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            setFirstLoad(false);
        }
    },[firstLoad])

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    let isMobile: boolean = (width <= 768);
    function setPrimary(phone: string) {
        if (!phone) {
            setPrimaryPhone("");
            return;
        }
        setPrimaryPhone(phone);
    }
    function setAlt(phone: string) {
        if (!phone) {
            setAltPhone("");
            return;
        }
        setAltPhone(phone);
    }

    function setUploadProgress(progress: number) {
        setProgress(progress);
    }
    function fileExists(fileName:string)
    {
        let matches = files.find((file:File,i:number) =>{
            return file.name.toLocaleLowerCase() === fileName.toLocaleLowerCase();
        })
        return matches;
    }

    function handleDrop(newFiles: FileList) {
        let fileList: File[] = [...files as []];
        let currentFileSizes = 0;
        let finalSize = fileSize;
        for (let i = 0; i < newFiles.length; i++) {
            let file = newFiles[i] as File;
            if (fileExists(file.name))
                continue;
            fileList.push(file);
            currentFileSizes += file.size;
        }
        finalSize += currentFileSizes;
        setFiles(fileList);
        setFileSize(finalSize);
        if (finalSize > ByteLimit)
            setShowUploadLimitBreach(true);
    }

    function deleteFile(index: number) {
        let fileList: File[] = [...files as []];
        let file = files![index];
        let newSize = fileSize - file.size;
        fileList.splice(index, 1);
        if (newSize < ByteLimit)
            setShowUploadLimitBreach(false);
        setFileSize(newSize);
        setFiles(fileList);
    }

    function handleToolTip()
    {
        if (showToolTip)
        {
            ReactTooltip.hide(toolTipRef);
            setShowToolTip(false);
        }
        else
        {
            ReactTooltip.show(toolTipRef);
            setShowToolTip(true);
        }
    }
    return <div>
        <CSSTransition in={showSuccess} timeout={300}
            classNames="claim-transition"
            unmountOnExit
            onExited={() => setShowStart(true)}>
            <ClaimSuccess claimNumber={claimPackage.claimNumber} claimType={ClaimType.Property}/>
        </CSSTransition>
        <CSSTransition in={showStart} timeout={300}
            classNames="claim-transition"
            unmountOnExit
            onExited={() => setShowSuccess(true)}>
            <div className="property-claim">
                <div>
                    <h1>REPORT A CLAIM: PROPERTY (step 2 of 2)</h1>
                    <h2 className="lossdate">Loss date of {PrettyPrintDate(claimPackage.lossDate)}</h2>
                    <p><strong><span className="red-ast">*</span> denotes required field(s)</strong></p>
                </div>
                <div className="form-horizontal">
                    <div className="form-group">
                        <p className="col-lg-6 col-sm-12 col-xs-12 control-label">Enter the name on the policy<span className="red-ast">*</span>:</p>
                        <div className="col-lg-6 col-sm-12 col-xs-12">
                            
                                <label htmlFor="policy-first" className="sr-only">Policy holder name required</label>
                                <input type="text" id="policy-first" name="Policy Holder Name" aria-invalid={showError && policyName === ""} aria-required aria-describedby="firstError" className="form-control" placeholder="Policy Holder" value={policyName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setPolicyName(e.target.value);
                                }} />
                                
                                <p id="firstError" className={showError && policyName === "" ? "error" : "error-hidden"}>This field is required</p>
                            
                        </div>
                    </div>
                    <div className="form-group">
                        <p className="force-left col-lg-12 col-sm-12 col-xs-12 control-label">If you are not our policyholder, what is your name and relation to the claim (optional)?</p>
                    </div>
                    <div className="form-group">
                        <div>
                            <div className="col-lg-4 col-sm-4 col-xs-4">
                                <label htmlFor="relation-first" className="sr-only">Relation First Name required if not policy holder</label>
                                <input type="text" id="relation-first" name="Relation First Name" aria-invalid={showError && altFirst !== "" && altLast === ""} aria-describedby="relationFirstError" className="form-control" placeholder="First" value={altFirst} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setAltFirst(e.target.value);
                                }} />
                                <p id="relationFirstError" className={showError && altLast !== "" && altFirst === "" ? "error" : "error-hidden"}>This field is required</p>
                            </div>
                            <div className="col-lg-4 col-sm-4 col-xs-4">
                                <label htmlFor="relation-last" className="sr-only">Relation Last Name required if not policy holder</label>
                                <input type="text" id="relation-last" name="Relation Last Name" aria-required={altFirst !== "" && altLast !== ""} aria-invalid={showError && altFirst !== "" && altLast === ""} aria-describedby="relationLastError" className="form-control" placeholder="Last" value={altLast} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setAltLast(e.target.value);
                                }} />
                                <p id="relationLastError" className={showError && altFirst !== "" && altLast === "" ? "error" : "error-hidden"}>This field is required</p>
                            </div>
                            <div className="col-lg-4 col-sm-4 col-xs-4">
                                <label htmlFor="relation-type" className="sr-only">Relation to policy holder if not policy holder</label>
                                <select className="form-control" id="relation-type" aria-invalid={showError && altRelation === "" && ((altLast !== "" && altFirst === "") || (altLast === "" && altFirst !== "") || (altLast !== "" && altFirst !== ""))} aria-describedby="relationTypeError" name="Relation to policy holder" value={altRelation} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                    setAltRelation(e.target.value);
                                }}>
                                    <option value="">Select...</option>
                                    <option value="Agent">Agent</option>
                                    <option value="Contractor">Contractor</option>
                                    <option value="Relative">Relative</option>
                                    <option value="Friend">Friend</option>
                                    <option value="Other">Other</option>
                                </select>
                                <p id="relationTypeError" className={showError && altRelation === "" && ((altLast !== "" && altFirst === "") || (altLast === "" && altFirst !== "") || (altLast !== "" && altFirst !== "")) ? "error" : "error-hidden"}>This field is required</p>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <p className="force-left col-lg-12 col-sm-12 col-xs-12 control-label">At which address listed on your policy did the loss occur<span className="red-ast">*</span>?</p>
                    </div>
                    <div className="form-group">
                        <div className="col-lg-5 col-md-11 col-sm-12 col-xs-11 mobile-padding-down">
                            <label htmlFor="policy-street" className="sr-only">Policy location Street Name required</label>
                            <input type="text" id="policy-street" aria-invalid={showError && street === ""} aria-required aria-describedby="streetError" name="Policy location street name" className="form-control" placeholder="Street" value={street} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setStreet(e.target.value);
                            }} />
                            <p id="streetError" className={showError && street === "" ? "error" : "error-hidden"}>This field is required</p>
                        </div>
                        <div className="col-lg-3 col-md-5 col-sm-4 col-xs-4">
                            <label htmlFor="policy-city" className="sr-only">Policy location city required</label>
                            <input type="text" id="policy-city" aria-invalid={showError && city === ""} aria-required aria-describedby="cityError" name="Policy location city" className="form-control" placeholder="City" value={city} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setCity(e.target.value);
                            }} />
                            <p id="cityError" className={showError && city === "" ? "error" : "error-hidden"}>This field is required</p>
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                            <label htmlFor="policy-state" className="sr-only">Policy Location state required</label>
                            <input type="text" id="policy-state" aria-invalid={showError && state === ""} aria-required aria-describedby="stateError" name="Policy Location state" className="form-control" placeholder="State" maxLength={2} value={state} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setState(e.target.value);
                            }} />
                            <p id="stateError" className={showError && state === "" ? "error" : "error-hidden"}>This field is required</p>
                        </div>
                        <div className="col-lg-2 col-sm-4 col-md-4 col-xs-4">
                            <label htmlFor="policy-zip" className="sr-only">Policy location zipcode required</label>
                            <input type="text" inputMode="numeric" aria-invalid={showError && zip === ""} aria-required aria-describedby="zipError" pattern="[0-9]*" id="policy-zip" name="Policy location zipcode" className="form-control" placeholder="Zipcode" maxLength={5} value={zip} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setZip(e.target.value.replace(/\D/g,''));
                            }} />
                            <p id="zipError" className={showError && zip === "" ? "error" : "error-hidden"}>This field is required</p>
                        </div>
                    </div>
                    <div className="form-group">
                        <p className="force-left col-lg-12 col-sm-12 col-xs-12 control-label">Please enter the policyholder's primary phone number and optional alternate if available:</p>
                    </div>
                    <div className="form-group">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <label htmlFor="primary-phone" className="col-lg-6 col-md-4 col-sm-6 col-xs-6 control-label">Primary Phone<span className="red-ast">*</span>:</label>
                            <div className="col-lg-6 col-md-8 col-sm-6 col-xs-6">
                                <PhoneInput id="primary-phone" placeholder="(123)-456-7890" name="Primary Phone" aria-invalid={showError && ((primaryPhone === "") || (primaryPhone !== "" && !isValidPhoneNumber(primaryPhone)))} aria-required aria-describedby="primaryPhoneError" country="US" international={false} className="form-control" value={primaryPhone} maxLength={14} onChange={setPrimary} />
                            </div>
                            <p id="primaryPhoneError" className={showError && ((primaryPhone === "") || (primaryPhone !== "" && !isValidPhoneNumber(primaryPhone))) ? "error" : "error-hidden"}>
                                {primaryPhone !== "" && !isValidPhoneNumber(primaryPhone) ? "Please provide a valid phone number" : "This field is required"}</p>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <label htmlFor="alt-phone" className="col-lg-6 col-md-4 col-sm-6 col-xs-6 control-label">Alternate Phone:</label>
                            <div className="col-lg-6 col-md-8 col-sm-6 col-xs-6">
                                <PhoneInput id="alt-phone" placeholder="(123)-456-7890" name="Alternate Phone" aria-invalid={showError && (altPhone !== "" && !isValidPhoneNumber(altPhone))} aria-describedby="altPhoneError" country="US" international={false} className="form-control" value={altPhone} maxLength={14} onChange={setAlt} />
                            </div>
                            <p id="altPhoneError" className={showError && (altPhone !== "" && !isValidPhoneNumber(altPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="email" className="col-lg-6 col-sm-12 col-xs-12 control-label">What is the policyholder's email<span className="red-ast">*</span>?</label>
                        <div className="col-lg-6 col-sm-12 col-xs-12">
                            <input id="email" name="Email" placeholder="sample@domain.com" className="form-control" aria-invalid={showError && ((email === "") || (email !== "" && !ValidateEmail(email)))} aria-required aria-describedby="emailError" type="email" value={email} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setEmail(e.target.value);
                            }} />

                            <p className={showError && ((email === "") || (email !== "" && !ValidateEmail(email))) ? "error" : "error-hidden"}>
                                {email !== "" && !ValidateEmail(email) ? "Please provide a valid email" : "This field is required"}</p>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="damage-explanation" className="force-left col-lg-12 col-sm-12 col-xs-12 control-label">Please tell us what happened and what was damaged<span className="red-ast">*</span>:</label>
                    </div>
                    <div className="form-group">
                        <div className="col-lg-12 col-sm-12 col-xs-12">
                            <textarea id="damage-explanation" name="Damage Explanation" aria-invalid={showError && explanation === ""} aria-required aria-describedby="damageError" className="form-control" maxLength={700} rows={6} value={explanation} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                setExplanation(e.target.value);
                            }} />
                            <p id="damageError" className={showError && explanation === "" ? "error" : "error-hidden"}>This field is required</p>
                            <div>
                                <p><strong>Maximum 700 characters.  You have used {explanation.length} characters.</strong></p>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                            <label htmlFor="other-claim" className="remove-left-padding control-label col-lg-12 col-sm-12 col-xs-12">Is your claim only for damage to a tree, fence, power line, or food spoilage?  If not, select, NA.<span className="red-ast">*</span></label>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6">
                            <select id="other-claim" name="Reporting other damage" aria-invalid={showError && otherDamage === ""} aria-required aria-describedby="otherDamageError" className="form-control" value={otherDamage} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                setOtherDamage(e.target.value);
                            }}>
                                <option value="N/A">N/A</option>
                                <option value="Yes">Yes</option>
                            </select>
                            <p id="otherDamageError" className={showError && otherDamage === "" ? "error" : "error-hidden"}>This field is required</p>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                            <label htmlFor="damage-amount" className="remove-left-padding control-label col-lg-12 col-sm-12 col-xs-12">In your estimation - what is the amount of your damages<span className="red-ast">*</span>?</label>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6">
                            <select id="damage-amount" name="Damage Amount" aria-invalid={showError && damageAmount === ""} aria-required aria-describedby="damageAmountError" className="form-control" value={damageAmount} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                setDamageAmount(e.target.value);
                            }}>
                                <option value="">Select...</option>
                                <option value="Up to $5,000">Up to $5,000</option>
                                <option value="$5,000 to $25,000">$5,000 to $25,000</option>
                                <option value="Over $25,000">Over $25,000</option>
                                <option value="I don't know">I don't know</option>
                            </select>
                            <p id="damageAmountError" className={showError && damageAmount === "" ? "error" : "error-hidden"}>This field is required</p>
                        </div>
                    </div>
                    <div className="form-group">
                        <p className="force-left col-lg-12 col-sm-12 col-xs-12 control-label">Would you like to upload a photo or PDF file to attach to your claim?</p>
                    </div>
                    <div className="form-group uploader">
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 uploader-button-container">
                            <label htmlFor="claim-uploads" className="btn btn-primary uploader-button"><i className="fa fa-paperclip" />&nbsp;Browse Files
                            <input id="claim-uploads" className="file-uploader" aria-describedby="fileUploadError" type="file" multiple onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                handleDrop(e.target.files as FileList);
                            }} /></label>
                            
                        </div>
                        <div className="col-lg-8 col-md-6 col-sm-6 col-xs-6 learn-more">
                        <p>Using <span className={uploadLimitBreached ? "error" : ""}>{fileSize < 10000 ? (fileSize / 1024 / 1024).toFixed(3) : (fileSize / 1024 / 1024).toFixed(2)}MB</span> out of <strong>9MB</strong> limit. 
                            <button className="learn-more-link" ref={ref => toolTipRef = ref} type="button" onClick={() =>{handleToolTip();}} data-tip={getLearnMore()}>Learn More</button>
                        </p>
							{/*@ts-ignore*/}
				            <ReactTooltip afterHide={AfterToolTipHide} afterShow={AfterToolTipShow} className="limitTooltip opaque" offset={{ left: 50 }} clickable={true} place="top" type="info" effect="solid" html={true} />
                        </div>
                    </div>
                    <p id="fileUploadError" className={uploadLimitBreached ? "error" : "error-hidden"}>You are over the upload size limit.  Remove or choose other files.</p>
                    <div className="col-lg-12">
                        {isMobile ? <FilesTable files={files} deleteFile={deleteFile} /> : null}
                        {isMobile ? null :
                            <FileDragAndDrop handleDrop={handleDrop}>
                                <div className="file-drag">
                                    <h2>Or drag files here</h2>
                                    <FilesTable files={files} deleteFile={deleteFile} />
                                </div>
                            </FileDragAndDrop>
                        }
                    </div>
                    {showError ? <p role="alert" aria-hidden={!showError} className="error">There are errors in your submissions.  Please check your information and correct any errors.</p> : null}
                    <div aria-hidden={!submitting && responseError === ""} className="col-lg-12 col-md-12 col-sm-12 col-xs-12 progress-container">
                        {files.length > 0 && submitting && progress !== 100 ? <h4>Uploading attachments for your claim, please wait...</h4> : null}
                        {submitting && progress === 100 ? <h4>Submitting your claim, please wait...<i className="fa fa-spinner fa-spin"></i></h4> : null}
                        {files.length > 0 && submitting && progress !== 0 ? <ProgressBar aria-valuemin={0} aria-valuemax={100} aria-valuenow={progress} striped={true} animated={true} now={progress} label={`${progress}%`} /> : null}
                        {responseError !== "" && !submitting ? <p role="alert" aria-hidden={responseError === "" && !submitting} className="error">We could not submit your claim.  {responseError}</p> : null}
                    </div>
                    <div className="form-group button-group">
                        <button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" onClick={() => { goBack(); }}><i className="fa fa-arrow-left" aria-hidden="true" />&nbsp;BACK</button>
                        <button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" disabled={submitting} onClick={() => { submitClaim(); }}><i className="fa fa-upload" aria-hidden="true" />&nbsp;FINISH</button>
                    </div>
                </div>
            </div>
        </CSSTransition>
    </div>;

    function getLearnMore() {
        return `<p id='learn-more-tip' class='upload-tip' role='tooltip'>9MB is approximately 3 photos on a modern smartphone or tablet.  This size varies by your image quality settings and device camera. When taking photos please avoid the RAW file format as the file size exponentially increases and you will
        not be able to include these.  Disabling RAW photos varies by Android or iOS so consult your camera app's settings.</p>`;
    }

    function goBack() {
        progressBack();
    }

    function validateClaim(claim: Claim) {
        if (!claim.policyName || claim.policyName === "")
            return false;
        if (claim.additionalAnswers["altContactFirst"] !== "" && claim.additionalAnswers["altContactLast"] === "")
            return false;
        if (claim.additionalAnswers["altContactFirst"] === "" && claim.additionalAnswers["altContactLast"] !== "")
            return false;
        if (claim.additionalAnswers["altContactFirst"] !== "" || claim.additionalAnswers["altContactLast"] !== "") {
            if (claim.additionalAnswers["altContactRelation"] === "")
                return false;
        }
        if (!claim.city || claim.city === "")
            return false;
        if (!claim.line1 || claim.line1 === "")
            return false;
        if (!claim.state || claim.state === "")
            return false;
        if (!claim.zipCode || claim.zipCode === "")
            return false;
        if (!claim.email || claim.email === "")
            return false;
        if (!ValidateEmail(claim.email))
            return false;
        if (!claim.explanation || claim.explanation === "")
            return false;
        if (!claim.primaryPhone || claim.primaryPhone === "")
            return false;
        if (!isValidPhoneNumber(claim.primaryPhone))
            return false;
        if (claim.altPhone && claim.altPhone !== "") {
            if (!isValidPhoneNumber(claim.altPhone))
                return false;
        }
        if (!claim.city || claim.city === "")
            return false;
        if (claim.additionalAnswers["otherDamage"] === "")
            return false;
        if (!claim.damageEstimation || claim.damageEstimation === "")
            return false;
        if (fileSize > ByteLimit)
            return false;
        return true;
    }

    function submitClaim() {
        var claim = new Claim();
        var date = new Date(damagedate as Date);
        claim.additionalAnswers["altContactFirst"] = altFirst;
        claim.additionalAnswers["altContactLast"] = altLast;
        claim.additionalAnswers["altContactRelation"] = altRelation;
        claim.additionalAnswers["otherDamage"] = otherDamage;
        claim.altPhone = altPhone;
        claim.city = city;
        claim.claimNumber = claimPackage.claimNumber;
        claim.damageEstimation = damageAmount;
        claim.email = email;
        claim.explanation = explanation;
        claim.policyName = policyName;
        claim.line1 = street;
        claim.lossDate = claimPackage.lossDate;
        claim.policyNumber = claimPackage.policyNumber;
        claim.primaryPhone = primaryPhone;
        claim.state = state;
        claim.type = ClaimType.Property;
        claim.websiteId = window["websiteId"];
        claim.zipCode = zip;

        let isValid = validateClaim(claim);
        if (isValid) {
            claim.altPhone = formatPhoneNumber(altPhone);
            claim.primaryPhone = formatPhoneNumber(primaryPhone);
            setShowError(false);
            setSubmitting(true);
            setShowUploadLimitBreach(false);
            Server.sendClaim(claim, files || [] as any, "quincy/claim/submission/type/property", setUploadProgress).then((result: string) => {
                if (result) {
                    if (result === "true") {
                        setResponseError("");
                        setShowStart(false);
                    }
                    else if (!result.startsWith("<!DOCTYPE"))
                    {
                        setResponseError(result.replace(/"/g, '')); //error string from API
                    }
                    else setResponseError("A general system error occurred.  Please contact the system administrator.")
                    setSubmitting(false);
                }
                else
                    setResponseError("A general system error occurred.  Please contact the system administrator.");
                setSubmitting(false);

            });
        }
        else setShowError(true);
    }
}
